/* istanbul ignore file */

// This utility function is covered by E2E test
// cypress/specs/mobile/rate-table.spec.ts
export const scrollToTableTop = (behavior: 'auto' | 'smooth' = 'auto') => {
  const rateTable = document.getElementById('mortgage-rate-table-app')
  if (rateTable) {
    const rect = rateTable.getBoundingClientRect()
    if (rect.top < 0) {
      rateTable.scrollIntoView({ behavior, block: 'start' })
    }
  }
}
